<template>
  <div class="icon-info-box">
    <img :src="iconUrl" />
    <div class="info">
      <span class="value">
        {{ value }}
        <span v-if="level !== ''" class="level"> {{ level }} </span>
      </span>
      <span class="label"> {{ label }} </span>
      <div v-if="inviteText" class="invite">
        <i class="el-icon-circle-plus-outline" />
        {{ inviteText }}
      </div>
      <div v-if="showListText" class="show-list" @click="showListAction">
        {{ showListText }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      icon: {
        type: String,
        default: ''
      },
      value: {
        default: ''
      },
      level: {
        type: String,
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      inviteText: {
        type: String,
        default: null
      },
      showListText: {
        type: String,
        default: null
      },
      showListAction: {
        type: Function,
        default: () => {}
      }
    },
    computed: {
      iconUrl() {
        return require(`@/assets/images/${this.icon}.svg`)
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_colors.scss";
  .icon-info-box {
    display: flex;
    align-items: flex-start;
    &:not(:last-of-type) {
      margin-bottom: 32px;
    }
    .info {
      display: flex;
      flex-direction: column;
      margin-left: 16px;
      .value {
        font-weight: bold;
        font-size: 28px;
        letter-spacing: 0.03em;
        text-transform: uppercase;
        color: $darker-blue;
        mix-blend-mode: normal;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .level {
          font-weight: 600;
          font-size: 12px;
          text-transform: capitalize;
          color: $lighter-gray;
          padding: 5px;
          background-color: $blue;
          margin-left: 20px;
          @media only screen and (max-width: 768px) {
            margin-left: 0;
          }
        }
      }
      .label {
        font-size: 16px;
        text-transform: capitalize;
        color: $darker-blue;
      }
    }
  }

  .invite {
    cursor: pointer;
    margin-top: 5px;
    float: left;
    font-weight: 600;
    font-size: 14px;
    color: $purple;
  }

</style>
